import React from 'react';
import './Badge.css';

function Badge({ variant, family, dot = false, className = '', children, ...props }) {
  const modifier = family ? `cw-badge--fam-${family}` : `cw-badge--${variant || 'neutral'}`;
  return (
    <span className={`cw-badge ${modifier}${className ? ` ${className}` : ''}`} {...props}>
      {dot && <span className="cw-badge-dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

export default Badge;
